import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Exploreindiapanindia() {



    const cardData = {

keyword: "Explore India / Pan India Cab Booking Services",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Explore India / Pan India Cab Booking Services for long-distance travel, holiday tours, business trips, family vacations, pilgrimage journeys, and interstate transportation. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and verified chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup and drop, flexible one-way and round-trip options, and nationwide coverage, we ensure a safe, comfortable, and hassle-free travel experience across India.",

topPlaces: [
    {
        title: "Rajasthan Heritage Circuit (Jaipur, Udaipur, Jodhpur)",
        description:
            "Explore the royal heritage of Rajasthan with visits to Jaipur, Udaipur, and Jodhpur, known for palaces, forts, lakes, and cultural richness. Pan India cab services make long-distance royal tours comfortable and convenient for families and groups."
    },
    {
        title: "Golden Triangle (Delhi, Agra, Jaipur)",
        description:
            "The Golden Triangle is India’s most popular tourist circuit covering Delhi, Agra, and Jaipur. Travelers can experience the Taj Mahal, historic forts, and vibrant markets with comfortable interstate cab services."
    },
    {
        title: "Himalayan Destinations (Manali, Shimla, Kasol)",
        description:
            "Experience the beauty of the Himalayas with scenic destinations like Manali, Shimla, and Kasol. These long-distance routes are ideal for adventure seekers and nature lovers booking pan India cab services."
    },
    {
        title: "South India Temples & Beaches (Rameshwaram, Madurai, Kanyakumari)",
        description:
            "Discover spiritual and coastal beauty across South India including Rameshwaram, Madurai, and Kanyakumari. These destinations are perfect for pilgrimage tours and cultural exploration."
    },
    {
        title: "Goa Coastal Tourism",
        description:
            "Goa is India’s top beach destination known for nightlife, beaches, water sports, and Portuguese heritage. Pan India cab services offer comfortable long-distance travel for vacationers."
    },
    {
        title: "Kashmir Valley (Srinagar, Gulmarg, Pahalgam)",
        description:
            "Kashmir is known as Heaven on Earth, offering breathtaking valleys, snow-covered mountains, and scenic lakes. It is a premium destination for long-distance cab tours across India."
    },
    {
        title: "Spiritual Circuit (Varanasi, Haridwar, Rishikesh)",
        description:
            "Explore India’s most sacred cities including Varanasi, Haridwar, and Rishikesh, famous for ghats, temples, yoga centers, and spiritual experiences."
    },
    {
        title: "Central India Wildlife (Bandhavgarh, Kanha, Pench)",
        description:
            "Central India is known for its national parks and tiger reserves. Wildlife enthusiasts can enjoy safari tours and nature exploration with comfortable cab travel."
    },
    {
        title: "East India Culture Tour (Kolkata, Puri, Darjeeling)",
        description:
            "East India offers cultural richness, beaches, and hill stations including Kolkata, Puri, and Darjeeling, making it a diverse travel experience for families and groups."
    },
    {
        title: "Western Coastal Drive (Mumbai to Goa, Konkan Belt)",
        description:
            "The Western Coastal route is famous for scenic highways, beaches, and Konkan beauty. It is one of the most preferred road trip experiences in India."
    }
],



services: [
{
name: "Pan India Cab Booking",
description: "Mumbai Airport Cab offers Pan India Cab Booking service for safe, comfortable, and reliable travel across all major cities and states in India. Whether you are planning long-distance travel, business trips, family vacations, religious tours, or intercity journeys, we provide well-maintained vehicles including Sedan, SUV, Innova, Innova Crysta, Kia Carens, Tempo Traveller, and luxury cars. Our professional chauffeurs ensure smooth highway driving, timely pickups, route planning, and complete travel assistance. With transparent pricing, flexible booking options, doorstep pickup and drop service, and 24x7 support, we make nationwide travel convenient, safe, and stress-free for every passenger."
},
{
name: "Explore India Cab Service",
description: "Explore India Cab Service by Mumbai Airport Cab is designed for travellers who want to discover destinations across India with comfort and convenience. From hill stations to beaches, heritage cities to pilgrimage sites, we offer fully customized travel solutions with experienced drivers and comfortable vehicles. Our service ensures flexible itineraries, safe long-distance travel, luggage convenience, and affordable packages for families, groups, and solo travellers. Enjoy a seamless travel experience while exploring India’s diverse landscapes with complete peace of mind."
},
{
name: "All India Taxi Service",
description: "All India Taxi Service provides reliable intercity and interstate transportation across India for business, tourism, and personal travel needs. Mumbai Airport Cab offers a wide range of vehicles with professional chauffeurs who are experienced in long-route driving and highway safety. We ensure comfortable seating, air-conditioned rides, transparent pricing, and flexible travel plans. Whether it is a one-way trip or multi-city journey, our service guarantees safe and efficient travel anywhere in India."
},
{
name: "India Wide Cab Booking",
description: "India Wide Cab Booking service allows customers to book taxis for travel across multiple states and cities with ease and convenience. Mumbai Airport Cab provides customized travel solutions for family tours, corporate travel, pilgrimage trips, and holiday packages. Our vehicles are equipped for long-distance comfort, offering spacious seating, luggage space, and experienced drivers. We focus on punctuality, safety, and smooth travel coordination for a hassle-free nationwide journey."
},
{
name: "Intercity Cab India",
description: "Intercity Cab India service is ideal for passengers travelling between cities for work, tourism, or personal reasons. Mumbai Airport Cab ensures reliable transportation with professional chauffeurs, clean vehicles, and flexible pickup and drop options. Whether you are travelling for meetings, vacations, or family visits, we provide affordable and comfortable intercity travel solutions with complete safety and convenience."
},
{
name: "Long Distance Cab India",
description: "Long Distance Cab India service offers comfortable transportation for extended road trips across states and regions. Mumbai Airport Cab provides well-maintained vehicles suitable for highway travel, ensuring safety, comfort, and reliability. Our experienced drivers are trained for long routes and ensure smooth journeys with proper rest stops and route optimization. We provide affordable pricing and customized travel plans for all long-distance requirements."
},
{
name: "India Tour Cab Service",
description: "India Tour Cab Service by Mumbai Airport Cab offers customized travel packages for sightseeing tours, cultural exploration, heritage trips, and vacation travel across India. Our service includes comfortable vehicles, professional chauffeurs, and flexible itineraries designed according to customer preferences. We ensure a stress-free travel experience with complete assistance for family tours, group travel, and solo journeys across popular tourist destinations."
},
{
name: "Pan India Car Rental",
description: "Pan India Car Rental service provides nationwide vehicle rental solutions for business travel, tourism, and personal transportation. Mumbai Airport Cab offers a wide fleet of vehicles suitable for all types of journeys including city travel, outstation trips, and long-distance tours. With professional drivers, transparent pricing, and flexible booking options, we ensure reliable and comfortable transportation anywhere in India."
},
{
name: "India Travel Taxi Service",
description: "India Travel Taxi Service offers convenient and affordable transportation across cities and states for all types of travel needs. Mumbai Airport Cab provides experienced chauffeurs, well-maintained vehicles, and flexible travel options for families, tourists, and corporate clients. We focus on safety, comfort, and punctuality, ensuring a smooth travel experience for every journey across India."
},
{
name: "Nationwide Cab Service India",
description: "Nationwide Cab Service India by Mumbai Airport Cab ensures seamless transportation across all regions of the country. Whether it is a business trip, family vacation, or pilgrimage tour, we provide reliable vehicles and professional drivers for long-distance travel. Our service includes transparent pricing, flexible itineraries, and 24x7 support for a stress-free travel experience across India."
},
{
name: "India Road Trip Cab",
description: "India Road Trip Cab service is perfect for travellers who love exploring highways and scenic routes across the country. Mumbai Airport Cab offers comfortable vehicles, experienced drivers, and customized travel plans for road trips across India. We ensure safety, convenience, and flexibility so customers can enjoy memorable journeys with family and friends."
},
{
name: "India Outstation Cab Service",
description: "India Outstation Cab Service provides reliable transportation for long-distance travel between cities and states. Mumbai Airport Cab offers comfortable vehicles, professional chauffeurs, and flexible travel schedules for holiday trips, business travel, and family tours. We ensure smooth highway travel with safety, comfort, and affordability at the core of our service."
},
{
name: "India Holiday Travel Cab",
description: "India Holiday Travel Cab service is designed for vacationers looking for comfortable and stress-free travel across tourist destinations in India. Mumbai Airport Cab provides customized holiday packages with professional drivers and well-maintained vehicles. We ensure smooth travel experiences covering beaches, hill stations, heritage cities, and pilgrimage locations."
},
{
name: "India Pilgrimage Cab Service",
description: "India Pilgrimage Cab Service offers safe and comfortable transportation for religious tours and spiritual journeys across India. Mumbai Airport Cab provides experienced drivers familiar with pilgrimage routes, ensuring smooth travel to temples, holy cities, and sacred destinations. We focus on comfort, safety, and timely travel for devotees and groups."
},
{
name: "India One Way Taxi",
description: "India One Way Taxi service provides affordable travel solutions for passengers who need transportation without return charges. Mumbai Airport Cab offers flexible pickup and drop locations across cities in India with transparent pricing and comfortable vehicles. Our service is ideal for business travel, relocation, and intercity journeys."
},
{
name: "India Round Trip Cab",
description: "India Round Trip Cab service offers complete return journey solutions for family vacations, business trips, and tourism travel across India. Mumbai Airport Cab provides well-maintained vehicles, professional chauffeurs, and flexible schedules to ensure smooth round-trip transportation with comfort and reliability."
},
{
name: "India Family Tour Cab",
description: "India Family Tour Cab service is designed for families travelling together across India for vacations, pilgrimages, or sightseeing trips. Mumbai Airport Cab offers spacious vehicles, comfortable seating, luggage space, and professional drivers to ensure safe and enjoyable travel experiences for families of all sizes."
},
{
name: "India Corporate Travel Cab",
description: "India Corporate Travel Cab service provides reliable transportation solutions for business professionals and companies travelling across cities and states. Mumbai Airport Cab offers punctual service, executive vehicles, and professional chauffeurs to ensure smooth business travel experiences with comfort and efficiency."
},
{
name: "India Luxury Travel Cab",
description: "India Luxury Travel Cab service offers premium transportation for high-end travel experiences across India. Mumbai Airport Cab provides luxury vehicles with advanced comfort features, professional chauffeurs, and personalized travel services. Ideal for VIP travel, weddings, corporate executives, and premium tourism experiences."
}
],

tableData: [
["Pan India Cab Booking","Explore India Cab Service"],
["All India Taxi Service","India Wide Cab Booking"],
["Intercity Cab India","Long Distance Cab India"],
["India Tour Cab Service","Pan India Car Rental"],
["India Travel Taxi Service","Nationwide Cab Service India"],
["India Road Trip Cab","India Outstation Cab Service"],
["India Holiday Travel Cab","India Pilgrimage Cab Service"],
["India One Way Taxi","India Round Trip Cab"],
["India Family Tour Cab","India Corporate Travel Cab"],
["India Luxury Travel Cab","India Travel Taxi Service India"]
],



whychoose: [
    {
        WhyChooseheading: "Reliable Pan India Cab Booking Services",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Pan India Cab Booking Services for business travel, family vacations, airport transfers, pilgrimages, corporate transportation, and long-distance journeys across India."
    },
    {
        WhyChooseheading: "Travel Anywhere Across India",
        WhyChoosedescription: "Customers can book cabs for travel to major cities, tourist destinations, religious places, hill stations, business hubs, and remote locations throughout India."
    },
    {
        WhyChooseheading: "Perfect for Corporate and Leisure Travel",
        WhyChoosedescription: "Whether you are attending business meetings, corporate events, family functions, weddings, vacations, or sightseeing tours, we provide comfortable transportation solutions."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and luxury vehicles according to your group size and travel requirements."
    },
    {
        WhyChooseheading: "One-Way, Round Trip, and Multi-City Packages",
        WhyChoosedescription: "We offer flexible travel plans including one-way transfers, round trips, multi-city tours, customized itineraries, and long-duration travel packages."
    },
    {
        WhyChooseheading: "Airport Transfers Across Major Cities",
        WhyChoosedescription: "Our cab services cover airport pickups and drops at Mumbai, Delhi, Bangalore, Hyderabad, Chennai, Pune, Ahmedabad, Jaipur, and other major airports across India."
    },
    {
        WhyChooseheading: "Professional Drivers for Long-Distance Travel",
        WhyChoosedescription: "Our experienced chauffeurs are trained for interstate travel, ensuring safety, comfort, punctuality, and a hassle-free journey."
    },
    {
        WhyChooseheading: "Ideal for Families, Groups, and Corporate Clients",
        WhyChoosedescription: "From solo travelers and families to large groups and corporate teams, we provide suitable transportation solutions for every travel requirement."
    }
]
};

const faqData = [
    {
        question: "What are Pan India Cab Booking Services?",
        answer: "Pan India Cab Booking Services allow customers to hire cabs for travel across different cities, states, tourist destinations, business hubs, and pilgrimage locations throughout India."
    },
    {
        question: "Can I book a cab for interstate travel?",
        answer: "Yes, Mumbai Airport Cabs provides interstate cab services covering major destinations across India."
    },
    {
        question: "Which vehicles are available for Pan India travel?",
        answer: "Customers can choose Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles."
    },
    {
        question: "Do you provide one-way and round-trip bookings?",
        answer: "Yes, one-way transfers, round trips, multi-city tours, and customized travel packages are available."
    },
    {
        question: "Can I book a cab for religious tours and pilgrimage trips?",
        answer: "Yes, customers frequently book cabs for Char Dham Yatra, Jyotirlinga Tours, Shirdi, Tirupati, Vaishno Devi, and other religious destinations."
    },
    {
        question: "Are corporate travel services available across India?",
        answer: "Yes, we provide transportation solutions for business meetings, conferences, corporate events, employee travel, and executive transportation."
    },
    {
        question: "Do you provide Tempo Travellers and Mini Buses for groups?",
        answer: "Yes, Tempo Travellers, Mini Buses, and larger vehicles are available for family tours, corporate outings, educational trips, and group travel."
    },
    {
        question: "Can airport transfers be arranged in different cities?",
        answer: "Yes, airport pickup and drop services are available in major cities across India."
    },
    {
        question: "Is advance booking recommended for Pan India travel?",
        answer: "Yes, advance booking helps secure your preferred vehicle and ensures smooth travel planning, especially for long-distance trips."
    },
    {
        question: "How can I book Pan India Cab Services?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Rohit Malhotra",
        feedback:
            "We booked a multi-state road trip through Mumbai Airport Cabs and the experience was outstanding. The vehicle was comfortable, the driver was experienced, and the entire journey was perfectly managed.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Ananya Kapoor",
        feedback:
            "Our family used Pan India Cab Services for a religious tour covering multiple cities. Everything was well organized, and the travel experience was smooth, safe, and enjoyable.",
        rating: 5
    }
];








































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pan India Cab Booking Services",
"image": "https://www.mumbaiairportcabs.com/assets/images/pan-india-cab-booking-services.jpg",
"description": "Book Pan India cab booking services for long-distance travel, intercity trips, tours, pilgrimages, and nationwide travel across India. Mumbai Airport Cabs offers reliable all-India taxi service with professional drivers, comfortable vehicles, and flexible one-way and round-trip options.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/pan-india-cab-booking-services"
}
};








    return (
        <div>



<Helmet>
  <title>Pan India Cab Booking Services | All India Taxi Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Pan India cab booking services for intercity travel, tours, pilgrimages, and long-distance trips across India. Reliable nationwide taxi service with professional drivers and flexible one-way and round-trip options."
/>

<meta
 name="keywords"
 content="pan india cab booking, explore india cab service, all india taxi service, india wide cab booking, intercity cab india, long distance cab india, india tour cab service, pan india car rental, india travel taxi service, nationwide cab service india, india road trip cab, india outstation cab service, india holiday travel cab, india pilgrimage cab service, india one way taxi, india round trip cab, india family tour cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>





            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/119.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Exploreindiapanindia;